import * as React from 'react'
import { connect } from 'react-redux'
import { PhoneSystemHuntGroupEditFormComponent } from './PhoneSystemHuntGroupEditForm'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const formName = 'phoneSystemHuntGroupEdit'

export interface IHuntGroupFormData {
  phoneSystemId: string
  huntGroupId: string
  extensionIds: string[]
  name: string
  number: string
  huntSequence: string
}

export interface IPhoneSystemHuntGroupEditFormProps {
  onAfterSubmit: () => undefined
  initialValues?: IHuntGroupFormData
  isAdmin?: boolean
}

const stateToProps = ({ auth }) => ({
  isAdmin: (auth.user.roles && auth.user.roles.includes('ROLE_API_ADMIN')) || auth.adminToken,
})
const dispatchToProps = {}

export const PhoneSystemHuntGroupEditForm = flow<
  any,
  any,
  React.SFC<IPhoneSystemHuntGroupEditFormProps>
>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(PhoneSystemHuntGroupEditFormComponent)



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemHuntGroupEditForm/PhoneSystemHuntGroupEditForm.container.ts